import { useState, useEffect } from "react";
import axios, { CancelToken } from "axios";
import {
  OPERATIONS_APPLY_REVERSAL_ID,
  OPERATIONS_SEND,
} from "../../../constants/api";

const callAPI = async (url, source, method = "get", data) => {
  try {
    return await axios.request({
      url,
      method,
      data,
      cancelToken: source.token,
    });
  } catch (error) {
    return error.response;
  }
};

const useDetail = (id) => {
  const [source, setSource] = useState();
  const [refundLoading, setRefundLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);

  useEffect(() => {
    setSource(CancelToken.source());
    return () => source?.cancel("Component unmounted");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refund = async () => {
    setRefundLoading(true);
    const response = await callAPI(
      OPERATIONS_APPLY_REVERSAL_ID.replace("{id}", id),
      source
    );
    setRefundLoading(false);
    return response;
  };

  const send = async (email) => {
    setSendLoading(true);
    const response = await callAPI(OPERATIONS_SEND, source, "post", {
      id,
      email,
    });
    setSendLoading(false);
    return response;
  };

  return { refundLoading, sendLoading, refund, send };
};

export default useDetail;
